import React from 'react';
import StreamMismatchBadge from './StreamMismatchBadge';
import { getStatsUrl, getPortalUrl } from '../utils/streamUtils';

/**
 * Shared channel header: alias, HA badge, StreamMismatchBadge (when applicable), Stats/Portal links.
 * Used by PreviewArea, HAChannelGroup, and VideoGrid single-channel.
 */
const GripIcon = () => (
  <svg className="w-4 h-4 text-gray-400 flex-shrink-0" viewBox="0 0 16 16" fill="currentColor">
    <circle cx="5" cy="3" r="1.5" />
    <circle cx="11" cy="3" r="1.5" />
    <circle cx="5" cy="8" r="1.5" />
    <circle cx="11" cy="8" r="1.5" />
    <circle cx="5" cy="13" r="1.5" />
    <circle cx="11" cy="13" r="1.5" />
  </svg>
);

const ChannelHeader = ({
  alias,
  channelId,
  dashboardAlias,
  isHA = false,
  expectedStreams,
  memberCount,
  showGrip = false,
  className = '',
  onLinkClick
}) => {
  const statsUrl = getStatsUrl(dashboardAlias, channelId);
  const portalUrl = getPortalUrl(channelId);

  return (
    <div className={`flex-shrink-0 p-2 flex justify-between items-center bg-black bg-opacity-50 ${className}`.trim()}>
      <div className="flex items-center gap-2">
        {showGrip && <GripIcon />}
        <span className="text-white text-sm font-medium">{alias || channelId}</span>
        {isHA && <span className="text-violet-300 text-xs">HA</span>}
        {memberCount != null && (
          <StreamMismatchBadge
            expectedStreams={expectedStreams ?? 1}
            memberCount={memberCount}
          />
        )}
      </div>
      <div className="flex gap-2">
        {statsUrl && (
          <a
            href={statsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-blue-300 text-sm"
            onClick={onLinkClick}
          >
            Stats
          </a>
        )}
        <a
          href={portalUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 hover:text-blue-300 text-sm"
          onClick={onLinkClick}
        >
          Portal
        </a>
      </div>
    </div>
  );
};

export default ChannelHeader;
